const SCRAPED_ITEM_ANALYSIS_TYPES = {
  SUMMARY: 'Summary',
  MENU_TITLE: 'MenuTitle',
  DISH: 'DISH',
}

export default SCRAPED_ITEM_ANALYSIS_TYPES
